import React, {useState} from 'react'

const FormDatePicker = () => {
  const [value, setValue] = useState()

  const handleClick = () => {
    setValue(value)
    console.log('New value: ', value)
  }

  return <p onClick={handleClick}>Form date picker</p>
}

export default FormDatePicker
